import { displayContent } from 'modules/templateEditor/common';
import { ListEntryContainer, StyledCaption, StyledListTitle } from './SmsSmartOptIn.styled';
import { SmsSmartOptInLink } from './types';

type ListEntryProps = { asset: SmsSmartOptInLink; className: string; onClick: () => void };

export const SmsSmartOptInListEntry = ({ asset, className, onClick }: ListEntryProps) => {
  return (
    <ListEntryContainer
      className={className}
      data-test="sms-smart-opt-in-list-entry"
      onClick={onClick}
    >
      <StyledListTitle data-test="sms-smart-opt-in-list-entry-title">{asset.name}</StyledListTitle>
      <StyledCaption data-test="sms-smart-opt-in-list-entry-description">
        {asset.description || displayContent.strSmsSmartOptInDetailsDescriptionDefault}
      </StyledCaption>
    </ListEntryContainer>
  );
};
